import { cn } from '@/components/ui/utils';
import type { TaskNote } from '../types';

interface Props {
  notes: TaskNote[];
}

export function NoteThread({ notes }: Props) {
  if (notes.length === 0) return null;

  return (
    <div className="space-y-3" aria-label="Note thread">
      {notes.map((note) => {
        const isWorker = note.author === 'worker';
        const isAnswer = !isWorker;
        const authorLabel = note.author === 'worker' ? 'You' : note.author === 'claude' ? 'Claude' : 'Ken';

        return (
          <div
            key={note.id}
            className={cn(
              'rounded-[4px] px-4 py-3 border',
              isAnswer
                ? 'border-[rgba(184,150,62,0.25)] bg-[var(--color-warm-white)]'
                : 'border-[var(--border)] bg-white'
            )}
          >
            <div className="flex items-center gap-2 mb-1.5">
              {/* Author chip */}
              <span
                className={cn(
                  'text-[12px] font-[600] px-2 py-0.5 rounded-[4px]',
                  isAnswer
                    ? 'bg-[rgba(184,150,62,0.15)] text-[var(--color-gold-dark)]'
                    : 'bg-[rgba(27,58,45,0.1)] text-[var(--color-forest)]'
                )}
              >
                {authorLabel}
              </span>

              {note.is_blocker && (
                <span className="text-[11px] font-[500] uppercase tracking-wide text-[var(--destructive)]">
                  blocker
                </span>
              )}

              <span className="text-[12px] text-[var(--color-mid-gray)] ml-auto">
                {formatNoteTime(note.created_at)}
              </span>
            </div>

            <p className="text-[15px] text-[var(--color-charcoal)] leading-relaxed whitespace-pre-wrap">
              {note.body}
            </p>
          </div>
        );
      })}
    </div>
  );
}

function formatNoteTime(iso: string): string {
  const d = new Date(iso);
  const today = new Date();
  const isToday = d.toDateString() === today.toDateString();
  if (isToday) {
    return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  }
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) +
    ' ' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
}
